
// Chakra imports
import { Box, Button, Spinner, Stack } from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { AuthContext } from "contexts/AuthContext";
import { useLocation } from "hooks/useLocation";
import { useGroup } from "hooks/useGroup";
import { useBroadcast } from "hooks/useBroadcast";
import { ActionDrawer } from "components/drawer";
import LocationModal from "views/modal/location";
import DataTableNew from "components/table/DataTableNew";
import { columnsLocations } from "./columns/locations";
import { isOffline } from "lib/presence";
import OfflineFilter from "components/status/OfflineFilter";
import MultiSelectFilter from "components/filter/MultiSelectFilter";

export default function LocationsPage() {
  const { user } = useContext(AuthContext);
  const [groupItems] = useGroup({user});
  const [locationItems, loadingLoc, , refreshLoc] = useLocation({user});
  const [broadcastItems] = useBroadcast({user});

  // Each drop-down filter holds a list of chosen ids; an empty list means "any"
  const [filter, setFilter] = useState({
    locBroadcastIds: [],
    groupIds: [],
    offline: false
  })

  // How many locations have a red warning triangle (last ping or last sync too old)
  const offlineCount = locationItems.filter(loc => isOffline(loc)).length

  const locBroadcasts = locationItems.reduce((s, loc) => {
    const br = broadcastItems.find(i => i.id === loc.broadcastId)
    if (!br) return s
    if (s.find(o => o.id === br.id)) return s
    s.push(br)
    return s
  }, [])

  if (!user || !locationItems) {
    return <Stack justifyContent={'center'} alignItems={'center'} pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <Spinner size='xl' />
    </Stack>
  }

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }} flex="1" minH={0} display="flex" flexDirection="column">
      <DataTableNew
        columns={columnsLocations}
        data={locationItems.filter(loc => {
          if (filter.groupIds.length > 0 && !filter.groupIds.includes(loc.groupId)) return false
          if (filter.locBroadcastIds.length > 0 && !filter.locBroadcastIds.includes(loc.broadcastId) && !filter.locBroadcastIds.includes(loc.group?.broadcastId)) return false
          if (filter.offline && !isOffline(loc)) return false
          return true
        })}
        totalCount={locationItems.length}
        loading={loadingLoc}
        refresh={refreshLoc}
        resetPageKey={filter}
        defaultSort={[{ id: 'name', desc: false }]}
        filters={(
          <>
            <MultiSelectFilter label='Any group'
              options={groupItems.map(gr => ({ value: gr.id, label: gr.name }))}
              value={filter.groupIds}
              onChange={groupIds => setFilter({ ...filter, groupIds })} />
            <MultiSelectFilter label='Any broadcast'
              options={locBroadcasts.map(br => ({ value: br.id, label: br.name }))}
              value={filter.locBroadcastIds}
              onChange={locBroadcastIds => setFilter({ ...filter, locBroadcastIds })} />
            <OfflineFilter
              isChecked={filter.offline}
              count={offlineCount}
              onChange={offline => setFilter({ ...filter, offline })} />
          </>
        )}
        actions={(
          <ActionDrawer
            title='Create location'
            size='2xl'
            trigger={
              <Button colorScheme='brand' variant='solid' size='sm' borderRadius={30} px='8'>
                New location
              </Button>
            }
          >
            <LocationModal onChange={refreshLoc} />
          </ActionDrawer>
        )}
      />
    </Box>
  );
}
